
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Karegaonparktomumbaicab() {



    const cardData =
    {
        keyword: ' Koregaon Park to Mumbai Cab',
        heading: 'Skyline Cabs: Koregaon Park to Mumbai Cab',
        headingDescription: 'Skyline Cabs offers premium Koregaon Park to Mumbai Cab services for a smooth and stress-free journey. Whether you are heading to Mumbai for work, leisure, or an airport transfer, our well-maintained vehicles and professional drivers ensure a comfortable and timely ride. Enjoy affordable pricing, on-time pickups, and superior customer service when you travel with Skyline Cabs. Book your Koregaon Park to Mumbai cab today and experience reliable travel at its best.',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

       "topPlaces": [
    
        {
            "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
            "description": "A magnificent railway station and UNESCO-listed site, CSMT is one of the finest examples of Victorian Gothic Revival architecture in India. Built in 1887 during British rule, this historic structure features a blend of Indian and European design elements, including domes, turrets, stained-glass windows, and intricate carvings. It serves as the headquarters of the Central Railway and is one of the busiest railway stations in India. The illuminated station at night is a sight to behold, attracting architecture and history enthusiasts."
        },
        {
            "title": "Marine Drive",
            "description": "Known as the Queen’s Necklace, Marine Drive is a 3.6 km long boulevard along the coast of South Mumbai. The stretch is lined with palm trees and offers stunning views of the Arabian Sea, making it an ideal spot for evening strolls, jogging, or simply relaxing by the sea. At night, the streetlights along the curved road resemble a string of pearls, creating a breathtaking visual effect. Marine Drive is also home to some of Mumbai’s finest restaurants, cafes, and luxury hotels, making it a favorite hangout for locals and tourists alike."
        },
        {
            "title": "Elephanta Caves",
            "description": "A UNESCO World Heritage Site, the Elephanta Caves are a group of rock-cut temples located on Elephanta Island, approximately 11 km from Mumbai. These caves date back to the 5th-7th century AD and are primarily dedicated to Lord Shiva. The most famous attraction here is the massive three-headed sculpture of Trimurti, symbolizing the three aspects of Shiva: Creator, Preserver, and Destroyer. The journey to the caves involves a scenic ferry ride from the Gateway of India, making it an adventure-filled and culturally enriching experience."
        },
        {
            "title": "Siddhivinayak Temple",
            "description": "One of Mumbai's most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha and attracts thousands of devotees daily. Built in 1801, the temple is known for its beautiful idol of Ganesha, carved from a single black stone with an elephant trunk tilted to the right. Celebrities, politicians, and common devotees visit the temple to seek blessings. Tuesdays witness a massive crowd of worshippers, as the day is considered auspicious for Lord Ganesha. The temple's serene ambiance offers a spiritual retreat amid Mumbai’s fast-paced life."
        },
        {
            "title": "Juhu Beach",
            "description": "Famous for its vibrant atmosphere, Juhu Beach is one of Mumbai’s most popular attractions. Stretching along the Arabian Sea, it is a hub for locals and tourists seeking relaxation, fun activities, and delicious street food. Visitors can enjoy horse rides, camel rides, and local delicacies like pav bhaji, vada pav, and bhel puri from the numerous food stalls lining the beach. Juhu Beach is also a popular spot for Bollywood celebrity sightings, as many film stars reside in the nearby luxurious localities."
        },
        {
        "title": "Gateway of India",
        "description": "An iconic landmark, the Gateway of India is a must-visit destination in Mumbai. Overlooking the Arabian Sea, this grand arch was built in 1924 to commemorate the visit of King George V and Queen Mary to India. It serves as a historic reminder of the colonial era and is a popular spot for photography, ferry rides to Elephanta Caves, and enjoying the sea breeze. The surrounding area is bustling with street vendors, tourists, and local performers, adding to the vibrant charm of the place."
    },
    {
        "title": "Colaba Causeway",
        "description": "A shopper’s paradise, Colaba Causeway is known for its lively street markets, trendy cafes, and colonial-era architecture. It offers a diverse range of goods, including jewelry, handicrafts, clothing, antiques, and souvenirs at bargain prices. The area is also home to some of Mumbai’s iconic eateries, such as Leopold Café and Café Mondegar, which are must-visit spots for food lovers. The fusion of street shopping, historical charm, and vibrant cafes makes Colaba Causeway an unmissable attraction in Mumbai."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque and dargah situated on an islet in the Arabian Sea, Haji Ali Dargah is one of Mumbai’s most significant religious landmarks. Built in the 15th century, it houses the tomb of the Muslim saint Pir Haji Ali Shah Bukhari. The dargah is accessible via a narrow walkway during low tide, offering a unique experience as you walk toward this architectural marvel. It attracts visitors from all faiths, offering a peaceful retreat with mesmerizing views of the sea and skyline."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "An engineering marvel, the Bandra-Worli Sea Link is an eight-lane cable-stayed bridge that connects Bandra to Worli, significantly reducing travel time between the suburbs and South Mumbai. Spanning 5.6 km, it offers breathtaking views of the Mumbai skyline, especially at sunset and night when the bridge is beautifully illuminated. It is a symbol of Mumbai’s modern infrastructure and development, making it a favorite spot for photographers and travelers."
    },
    {
        "title": "Film City",
        "description": "Get a glimpse into Bollywood at Mumbai's famous Film City, officially known as Dadasaheb Phalke Chitranagari. Spread across 520 acres, it features multiple sets, including replicas of villages, urban streets, temples, and even forests, making it a key location for Bollywood films, TV shows, and commercials. Visitors can take guided tours to witness live shoots, explore film sets, and learn about the behind-the-scenes magic of India’s entertainment industry. For movie buffs, this is a dream destination."
    }
],

"services": [
    {
      "name": "Koregaon Park to Mumbai Airport Cab",
      "description": "Skyline Cabs provides a reliable and comfortable cab service from Koregaon Park to Mumbai Airport. With options like Innova, Ertiga, and luxury sedans, we ensure timely pickups and a smooth ride for airport transfers."
    },
    {
      "name": "Koregaon Park to Mumbai International Airport Cab",
      "description": "Travel to Mumbai International Airport from Koregaon Park with Skyline Cabs for a stress-free experience. We offer well-maintained vehicles and professional drivers for your convenience and safety."
    },
    {
      "name": "Koregaon Park to Mumbai Airport Drop Taxi",
      "description": "Choose Skyline Cabs for a punctual and hassle-free airport drop taxi from Koregaon Park to Mumbai Airport. Enjoy a comfortable ride in our air-conditioned vehicles, available 24/7."
    },
    {
      "name": "Koregaon Park to Mumbai Airport One Way Taxi",
      "description": "Book a one-way taxi from Koregaon Park to Mumbai Airport with Skyline Cabs. Our service is ideal for travelers who want a reliable and affordable ride without return booking obligations."
    },
    {
      "name": "Koregaon Park to Mumbai Round Trip",
      "description": "Skyline Cabs offers round-trip cab services from Koregaon Park to Mumbai. Whether it’s a day trip or a business visit, enjoy flexible return schedules and comfortable rides."
    },
    {
      "name": "Cab Service in Koregaon Park",
      "description": "Skyline Cabs provides reliable and timely cab services in Koregaon Park for local and outstation travel. Our fleet includes sedans, SUVs, and luxury vehicles suitable for every occasion."
    },
    {
      "name": "Koregaon Park to Santacruz Cab Fare",
      "description": "Need a ride to Santacruz from Koregaon Park? Skyline Cabs offers transparent fare pricing and clean, comfortable cabs driven by courteous professionals."
    },
    {
      "name": "Koregaon Park to Mumbai Central Cab",
      "description": "Travel from Koregaon Park to Mumbai Central with Skyline Cabs. Choose from Ertiga, Innova, or premium vehicles for a safe and relaxed journey."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Skyline Cabs offers dependable Pune to Mumbai Airport cab services. Enjoy on-time pickups, spacious vehicles, and professional drivers for a stress-free airport commute."
    },
    {
      "name": "Pune to Mumbai Ertiga Cab",
      "description": "For small families or groups, the Ertiga is a spacious and budget-friendly option. Skyline Cabs ensures a smooth ride from Pune to Mumbai in this popular MPV."
    },
    {
      "name": "Pune to Mumbai Innova Cab",
      "description": "Enjoy a premium travel experience from Pune to Mumbai in an Innova with Skyline Cabs. Perfect for corporate travel and family trips, the Innova provides extra legroom and comfort."
    },
    {
      "name": "Taxi Cab Service in Koregaon Park",
      "description": "Skyline Cabs offers efficient and affordable taxi cab services in Koregaon Park. Whether it's local errands or intercity trips, we’ve got your travel needs covered."
    },
    {
      "name": "Koregaon Park to Navi Mumbai Cab",
      "description": "Get to Navi Mumbai from Koregaon Park without delays. Skyline Cabs ensures timely service and multiple vehicle options to suit every traveler’s needs."
    },
    {
      "name": "Koregaon Park to Airport Cab Service",
      "description": "Skyline Cabs provides seamless airport cab services from Koregaon Park to Mumbai Airport, including Terminal 1, 2, and 3. Choose comfort, punctuality, and safety with us."
    },
    {
      "name": "Koregaon Park to Thane Cab Service",
      "description": "Skyline Cabs offers direct cab service from Koregaon Park to Thane. Travel in comfort and style with our air-conditioned vehicles and experienced drivers."
    },
    {
      "name": "Koregaon Park to Mumbai Airport Innova",
      "description": "Book an Innova from Koregaon Park to Mumbai Airport with Skyline Cabs for a luxurious and spacious ride. Perfect for travelers needing extra space or comfort."
    },
    {
      "name": "Innova Crysta on Rent in Koregaon Park",
      "description": "Rent an Innova Crysta in Koregaon Park with Skyline Cabs for luxury outstation travel. Ideal for business or family trips, with ample space and smooth performance."
    },
    {
      "name": "7 Seater Car on Rent in Koregaon Park",
      "description": "Need a 7-seater for your travel group? Skyline Cabs offers SUVs like the Ertiga and Innova Crysta in Koregaon Park, available for local and outstation rentals."
    },
    {
      "name": "Ertiga on Rent in Koregaon Park",
      "description": "Skyline Cabs offers the Ertiga on rent in Koregaon Park. It's a fuel-efficient and comfortable option for family outings and Mumbai trips alike."
    },
    {
      "name": "Luxury Car on Rent in Koregaon Park",
      "description": "Skyline Cabs provides luxury car rentals in Koregaon Park. Choose from a premium fleet for weddings, business travel, or special occasions."
    },
    {
      "name": "Pune Mumbai Skyline Cabs",
      "description": "Skyline Cabs specializes in Pune to Mumbai cab services. Whether it’s an airport drop, city visit, or business trip, trust us for reliability, comfort, and competitive pricing."
    },
    {
      "name": "Cab Service in Pune",
      "description": "Skyline Cabs offers dependable and professional cab service throughout Pune. Whether you're traveling to Mumbai or within city limits, our drivers and vehicles are at your service."
    }
  ],
  "tableData": [
    ["Koregaon Park to Mumbai Airport Cab", "Koregaon Park to Mumbai International Airport Cab"],
    ["Koregaon Park to Mumbai Airport Drop Taxi", "Koregaon Park to Mumbai Airport One Way Taxi"],
    ["Koregaon Park to Mumbai Round Trip", "Cab Service in Koregaon Park"],
    ["Koregaon Park to Santacruz Cab Fare", "Koregaon Park to Mumbai Central Cab"],
    ["Pune to Mumbai Airport Cab", "Pune to Mumbai Ertiga Cab"],
    ["Pune to Mumbai Innova Cab", "Taxi Cab Service in Koregaon Park"],
    ["Koregaon Park to Navi Mumbai Cab", "Koregaon Park to Airport Cab Service"],
    ["Koregaon Park to Thane Cab Service", "Koregaon Park to Mumbai Airport Innova"],
    ["Innova Crysta on Rent in Koregaon Park", "7 Seater Car on Rent in Koregaon Park"],
    ["Ertiga on Rent in Koregaon Park", "Luxury Car on Rent in Koregaon Park"],
    ["Pune Mumbai Skyline Cabs", "Cab Service in Pune"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Koregaon Park to Mumbai Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers reliable and timely cab services from Koregaon Park to Mumbai, ensuring that you reach your destination on time, whether it's for a business trip, family outing, or airport transfer. We prioritize punctuality and comfort every time."
    },
    {
        "WhyChooseheading": "Comfortable and Luxurious Vehicles",
        "WhyChoosedescription": "Enjoy a comfortable and smooth ride from Koregaon Park to Mumbai in our well-maintained vehicles. Choose from a range of vehicles including sedans, SUVs, and luxury cars, all equipped with air-conditioning and ample space for a relaxing travel experience."
    },
    {
        "WhyChooseheading": "Experienced Drivers for a Smooth Journey",
        "WhyChoosedescription": "Our professional drivers are not only skilled and experienced but also courteous and familiar with the best routes from Koregaon Park to Mumbai. They ensure a smooth and safe journey, navigating through traffic efficiently and safely."
    },
    {
        "WhyChooseheading": "Affordable Pricing with No Hidden Charges",
        "WhyChoosedescription": "Skyline Cabs offers competitive and transparent pricing for your Koregaon Park to Mumbai trip. With no hidden charges or unexpected fees, you’ll know the exact cost upfront, making your trip budget-friendly and stress-free."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Convenience",
        "WhyChoosedescription": "Whether you need a cab for an early morning flight or a late-night ride, Skyline Cabs is available 24/7. Our flexible service hours ensure that you can book a cab at any time of the day or night for your convenience."
    },
    {
        "WhyChooseheading": "Wide Selection of Vehicles for Every Need",
        "WhyChoosedescription": "From solo travelers to families or groups, we have the right vehicle for you. Choose from a variety of options, including hatchbacks, sedans, SUVs, and luxury vehicles, all of which are maintained to ensure maximum comfort and safety for your journey from Koregaon Park to Mumbai."
    },
    {
        "WhyChooseheading": "Quick and Easy Online Booking Process",
        "WhyChoosedescription": "Booking a cab from Koregaon Park to Mumbai is easy and fast with our user-friendly website and mobile app. Get fare estimates, book instantly, and track your cab in real-time to ensure a hassle-free experience from start to finish."
    },
    {
        "WhyChooseheading": "Safe and Secure Travel with Real-Time GPS Tracking",
        "WhyChoosedescription": "Skyline Cabs places a high priority on safety. All our vehicles are GPS-enabled, and our drivers are background-checked, providing you with peace of mind throughout your journey. Whether you're traveling for business or leisure, you can trust Skyline Cabs for secure and comfortable travel."
    }
]












    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a Koregaon Park to Mumbai cab with Skyline Cabs?',
            answer:
                'Booking is simple! You can reserve a cab via our website, Skyline Cabs mobile app, or by calling our customer support. Just enter Koregaon Park as your pickup and Mumbai as the destination, choose your vehicle, and confirm.',
        },
        {
            id: 2,
            question: 'What vehicle options are available from Koregaon Park to Mumbai?',
            answer:
                'We offer a range of vehicles including hatchbacks, sedans, SUVs, and luxury cars. Whether you’re booking a solo ride or traveling with family, we have a car to match your comfort level and style.',
        },
        {
            id: 3,
            question: 'Is the fare fixed for Koregaon Park to Mumbai or does it vary?',
            answer:
                'Skyline Cabs offers fixed, transparent pricing for this route. The fare includes tolls, taxes, and any extra charges — all clearly stated during the booking process.',
        },
        {
            id: 4,
            question: 'Can I book a round trip from Koregaon Park to Mumbai?',
            answer:
                'Absolutely! You can choose a one-way or round-trip option when booking your ride. Just let us know your return date and time if you’re planning a round trip.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Koregaon Park to Mumbai?',
            answer:
                'The average travel time is around 3 to 3.5 hours, depending on traffic. Our experienced drivers ensure a smooth and timely journey every time.',
        },
        {
            id: 6,
            question: 'Are your drivers trained and verified?',
            answer:
                'Yes, all Skyline drivers are professionally trained, background-verified, and experienced with long-distance routes. Your safety and comfort are our priorities.',
        },
        {
            id: 7,
            question: 'Can I pre-book a Koregaon Park to Mumbai cab?',
            answer:
                'Yes, advance bookings are available and recommended, especially during weekends or festive seasons. Use our app or website to reserve your preferred ride time and vehicle.',
        },
        {
            id: 8,
            question: 'Do you provide airport drop from Koregaon Park to Mumbai?',
            answer:
                'Yes, we offer direct cab services from Koregaon Park to Mumbai Airport (both Domestic and International). Share your flight details for on-time drop-off.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my Koregaon Park to Mumbai booking?',
            answer:
                'Of course! You can manage your booking via the Skyline app or website. We also offer flexible cancellation policies and 24/7 support if you need help.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for this route?',
            answer:
                'Skyline Cabs offers a blend of comfort, punctuality, and professional service. From Koregaon Park to Mumbai, our riders enjoy well-maintained vehicles, trained drivers, and honest pricing.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Arjun Bhagat",
            rating: 5,
            review: "Skyline Cabs provided an excellent cab service from Koregaon Park to Mumbai. The ride was peaceful, the driver was courteous, and everything was perfectly on time. Will definitely book again for my next trip."
        },
        {
            name: "Miss. Neha Kulkarni",
            rating: 4,
            review: "The booking process was seamless and the ride was comfortable. The driver kept a smooth pace and knew the best routes. Would love to see charging ports or USB options added in the car for longer journeys!"
        },
    ];
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Koregaon Park to Mumbai Cab Service",
  "image": "https://skylinecabs.com/assets/images/koregaon-park-to-mumbai-cab.jpg",
  "description": "Book Koregaon Park to Mumbai cab service with Skyline Cabs for a hassle-free journey in AC sedans or SUVs. Enjoy punctual pickups, professional drivers, and 24/7 service at affordable prices.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7348"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/koregaon-park-to-mumbai-cab-service"
  }
};



      
    


    return (
        <div>
<Helmet>
  <title>Koregaon Park to Mumbai Cab Service | 24/7 AC Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Koregaon Park to Mumbai cab service with Skyline Cabs for a hassle-free journey in AC sedans or SUVs. Enjoy punctual pickups, professional drivers, and 24/7 service at affordable prices." 
  />
  <meta 
    name="keywords" 
    content="Koregaon Park to Mumbai Cab Service, Cab from Koregaon Park to Mumbai, One-Way Taxi Koregaon Park to Mumbai, Round Trip Cab Koregaon Park to Mumbai, AC Cab Koregaon Park to Mumbai, SUV Taxi Koregaon Park to Mumbai, Skyline Cabs Koregaon Park to Mumbai, Affordable Taxi Koregaon Park Mumbai, 24/7 Cab Booking Koregaon Park to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/15.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Karegaonparktomumbaicab;